"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformRequestToUrl = exports.getAggregateDataForBuilding = exports._searchQueryApi = exports.searchQueryApi = exports.retryNoProperty = void 0;
var Api_1 = require("@/api/remote/Api");
var stateToSearchQuery_1 = require("@/transformers/stateToSearchQuery");
var searchQueryToUrl_1 = require("@/transformers/searchQueryToUrl");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var effects_1 = require("redux-saga/effects");
var getLanguageDetail = function (state, lanugageId) { return state.layout.language.languages.find(function (it) { return it.id === lanugageId; }); };
var formatRentPrice = function (searchQuery, data) {
    if (!searchQuery.isMap)
        return data;
    if (!data.aggregatedData)
        return data;
    return __assign(__assign({}, data), { aggregatedData: data.aggregatedData.map(function (it) {
            if (searchQuery.listingTypeId !== SfilterTypeGroup_1.ListingPurposeType.Rent)
                return it;
            return __assign(__assign({}, it), { minPrice: it.minPrice * 1000, maxPrice: it.maxPrice * 1000 });
        }) });
};
exports.retryNoProperty = function (retryLimit, searchQuery, languageCode) {
    var currentRetryCount, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                currentRetryCount = 0;
                data = null;
                _a.label = 1;
            case 1:
                if (!(retryLimit > currentRetryCount)) return [3 /*break*/, 4];
                currentRetryCount = currentRetryCount + 1;
                return [4 /*yield*/, effects_1.call(exports._searchQueryApi, searchQuery, languageCode)];
            case 2:
                data = _a.sent();
                if (data && data.properties && data.properties.length)
                    return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.delay(1000)];
            case 3:
                _a.sent();
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/, data];
        }
    });
};
exports.searchQueryApi = function (searchQuery) {
    var code1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getLanguageDetail, searchQuery.languageId)];
            case 1:
                code1 = (_a.sent()).code1;
                return [4 /*yield*/, exports.retryNoProperty(2, searchQuery, code1)];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
};
exports._searchQueryApi = function (searchQuery, languageCode) {
    return Api_1.api()
        .post(languageCode + "/api/property-search/getsearchproperties", searchQuery)
        .then(function (response) { return response.data; })
        .then(function (data) { return formatRentPrice(searchQuery, data); })
        .catch(function (e) { });
};
exports.getAggregateDataForBuilding = function (buildingIds, state, languageCode, pageSize) {
    var searchQuery = stateToSearchQuery_1.stateToSearchQuery(state, pageSize, 1);
    var requestParams = __assign(__assign({}, searchQuery), { buildingIds: buildingIds });
    return Api_1.api()
        .post(languageCode + "/api/property/getaggregateddataforbuilding", requestParams)
        .then(function (response) { return response.data; })
        .catch(function (_) { return null; });
};
exports.transformRequestToUrl = function (state, pageSize) {
    var page = state.results.resultResponses.length
        ? state.results.resultResponses[state.results.resultResponses.length - 1]
            .page
        : 1;
    var searchQuery = stateToSearchQuery_1.stateToSearchQuery(state, pageSize, page);
    var hash = window.location.hash;
    return "" + searchQueryToUrl_1.searchQueryToUrl(searchQuery) + hash;
};
